import React, { useContext } from 'react';
import { SiteContext } from '../../../context/SiteContext';

const InsuranceFailedRegistration = (): JSX.Element => {
  const { site } = useContext(SiteContext);

  const { brand } = site;

  const { brandPhoneNumbers } = brand;

  const { quotesAndRenewalsNumber } = brandPhoneNumbers;

  return (
    <div>
      <h3>Purchase could not be completed</h3>
      <p className='p2 m1-bottom'>Registration of the policy failed</p>
      <p className='p2'>
        Please contact our Customer Services team on {quotesAndRenewalsNumber}{' '}
        for assistance
      </p>
    </div>
  );
};

export default InsuranceFailedRegistration;
